// extracted by mini-css-extract-plugin
export default {"modal":"TransferModal_modal__ab5X6","label":"TransferModal_label__a7v6F","title":"TransferModal_title__jqfAE","fieldFeedback":"TransferModal_fieldFeedback__17VEq"};